import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Avatar, Grid, Paper, Tooltip, Typography
} from '@mui/material';

import CheckCircle from '@mui/icons-material/CheckCircle';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import ReportProblem from '@mui/icons-material/ReportProblem';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import PendingActions from '@mui/icons-material/PendingActions';

import { green, red, amber } from '@mui/material/colors';


const styleSheet = theme => ({
    paper: {
      [theme.breakpoints.up('xs')]: {
        width: 'calc(100% - 20px)',
      },
      [theme.breakpoints.up('sm')]: {
        width: 340,
      },
      maxWidth: 340,
      height: 84,
      marginTop: theme.spacing(3),
      //overflow: 'auto',
      padding: 20,
      '&:hover': {
          backgroundColor: '#f7f7f7',
          cursor: 'pointer'
      }
    },
    customerInfo: {
      float: 'left',
      maxWidth: 240,
      [theme.breakpoints.up('xs')]: {
        width: 'calc(100% - 60px - 24px)',
      },
      [theme.breakpoints.up('sm')]: {
        width: 240,
      },
    },
    avatar: {
        marginRight: 20,
        float: 'left',
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.text.secondary
    },
    customerTitle: {
        marginTop: 0,
        marginBottom: 5,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    contactName: {
        color: 'inherit'
    },
    contactEmail: {
        color: '#666666'
    },
    contactPhone: {
        color: '#666666'
    },
    contactGrid: {
        height: 17,
    }
});

class CustomerOverview extends Component {

    goTo(url) {
        const sterm = this.props.sterm;
        if (sterm != null)
        {
            localStorage.setItem('customersSterms', sterm);
        }
        this.props.history.push(`${url}`);
    }

    getAccountName = (customerName) => {

      var limit = 30;  //seems to be a good general fit
      if (customerName.length > limit) {
        // Find the space before that.
        let theSubstr = customerName.substring(0, limit);
        let lastSpaceIdx = theSubstr.lastIndexOf(' ');
        return customerName.substring(0, lastSpaceIdx) + '...';
      } else {
        return customerName;
      }
 
  }

    render() {
        const statusOk = green[300];
        const statusSuspended = red[300];
        const statusCaution = amber[400];
  

        const customer = this.props.customer;
        const classes = this.props.classes;

        let theUrl = "./customer?accountId=" + customer.accountId;
        let initials = customer.accountName[0];

        // Format the phone number
        /*let aPhone = customer.contactPhone;
        let formattedPhone = aPhone;
        if (aPhone != null && aPhone.length === 10)
        {
            formattedPhone = '+1 (' + aPhone.substring(0,3) + ') '
                               + aPhone.substring(3,6) + '-' + aPhone.substring(6);
        }*/

        return (
            <div>
                <Paper elevation={2} className={classes.paper}
                    onClick={() => {this.goTo(theUrl);}}>
                    <div style={{float:'left'}}>
                        <Avatar className={classes.avatar}>{initials}</Avatar>
                    </div>
                    <div className={classes.customerInfo}>
                        <Grid container direction="column" justifyContent="flex-start">
                        <Grid item>
                        <Typography className={classes.customerTitle} variant="h6">
                          {this.getAccountName(customer.accountName)}
                        </Typography>
                        </Grid>
                        {customer.accountNum && customer.accountNum.length > 0 &&
                        <Grid item>
                        <Typography variant="body2" className={classes.contactName}>{customer.accountNum}</Typography>
                        </Grid>
                        }
                        <Grid item>
                        <Typography variant="body2" className={classes.contactName} data-recording-sensitive>{customer.contactFirstName}&nbsp;{customer.contactLastName}</Typography>
                        </Grid>
                        <Grid item className={classes.contactGrid}>
                        <Typography variant="caption" className={classes.contactEmail} data-recording-sensitive>{customer.contactEmail}</Typography>
                        </Grid>
                        {/*<Grid item className={classes.contactGrid}>
                        <Typography variant="caption" className={classes.contactPhone} data-recording-sensitive>{formattedPhone}</Typography>
                        </Grid>*/}
                        </Grid>
                    </div>

                    { customer.accountStatus === 0 && customer.customerStatus !== 2 && customer.floatProblem === 0 && customer.declineCount === 0 && customer.soStatus !== 1 && customer.soStatus !== 2 &&
                     <div style={{float: 'right', marginTop: '4px', clear: 'right'}}>
                        <CheckCircle htmlColor={statusOk}/>
                    </div>
                    }
                    { customer.accountStatus === 0 && customer.customerStatus === 2 && customer.floatProblem === 0 && customer.declineCount === 0 &&
                     <div style={{float: 'right', marginTop: '4px', clear: 'right'}}>
                        <TransferWithinAStationIcon htmlColor={statusOk}/>
                    </div>
                    }
                    { customer.accountStatus === 0 && (customer.floatProblem === 1 || customer.declineCount > 0) &&
                     <div style={{float: 'right', marginTop: '4px', clear: 'right'}}>
                         <Tooltip title="Customer has funding issues">
                            <ReportProblem htmlColor={statusCaution}/>
                        </Tooltip>
                     </div>
                    }
                    { customer.accountStatus === 0 && !(customer.floatProblem === 1 || customer.declineCount > 0) && (customer.soStatus === 1) &&
                     <div style={{float: 'right', marginTop: '4px', clear: 'right'}}>
                         <Tooltip title="Customer has outstanding order">
                            <HourglassEmpty htmlColor={statusCaution}/>
                        </Tooltip>
                     </div>
                    }
                    { customer.accountStatus === 0 && !(customer.floatProblem === 1 || customer.declineCount > 0) && (customer.soStatus === 2) &&
                     <div style={{float: 'right', marginTop: '4px', clear: 'right'}}>
                         <Tooltip title="Customer has outstanding order that has not been sent to them">
                            <PendingActions htmlColor={statusCaution}/>
                        </Tooltip>
                     </div>
                    }
                    { customer.accountStatus === 1 &&
                     <div style={{float: 'right', marginTop: '4px', clear: 'right'}}>
                        <Tooltip title="Customer is suspended">
                            <PauseCircleFilled htmlColor={statusSuspended}/>
                        </Tooltip>
                     </div>
                    }

                </Paper>
        </div>
        );
    }
}

export default withStyles(styleSheet)(CustomerOverview);
